
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBoltGoogle as ObiBoltGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bolt-google.js';
 
 
 

 
 export const ObiBoltGoogle = createComponent({
   react: React,
   tagName: 'obi-bolt-google',
   elementClass: ObiBoltGoogleElement,
   events: {
     
   }
  });
 
 